import { BrowserRouter } from 'react-router-dom';
import Routing from './routes';
import React from 'react';
import ToastProvider from './components/ToastProvider';
import useAuthCheck from './hooks/useAuthCheck';

function App() {
  useAuthCheck();
  return (
    <BrowserRouter>
      <Routing />
      <ToastProvider />
    </BrowserRouter>
  )
}

export default App
